import {
  EVALUATION_DETAIL_LIST, 
  EVALUATION_DETAIL_LIST_SUCCESS, 
  EVALUATION_DETAIL_LIST_ERROR,
  EVALUATION_DETAIL_SEARCH_SET, 
  EVALUATION_DETAIL_SEARCH_CHANGE, 
  EVALUATION_DETAIL_PAGE_SET,
  EVALUATION_DETAIL_SEARCH_EVALUATION,
  EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS,
  EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR,
  EVALUATION_DETAIL_SEARCH_ANSWER,
  EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS,
  EVALUATION_DETAIL_SEARCH_ANSWER_ERROR, 
  EVALUATION_DETAIL_SEARCH_DOCUMENT,
  EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS,
  EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR, 
  EVALUATION_DETAIL_ADD_SET,
  EVALUATION_DETAIL_ADD_MODAL_SET,
  EVALUATION_DETAIL_ADD,
  EVALUATION_DETAIL_ADD_SUCCESS,
  EVALUATION_DETAIL_ADD_ERROR,
  EVALUATION_DETAIL_ADD_CHANGE,
  EVALUATION_DETAIL_DETAIL,
  EVALUATION_DETAIL_DETAIL_SUCCESS,
  EVALUATION_DETAIL_DETAIL_ERROR,
  EVALUATION_DETAIL_VIEW_MODAL_SET,
  EVALUATION_DETAIL_EDIT_CHANGE,
  EVALUATION_DETAIL_EDIT_MODAL_SET,
  EVALUATION_DETAIL_UPDATE,
  EVALUATION_DETAIL_UPDATE_SUCCESS,
  EVALUATION_DETAIL_UPDATE_ERROR,
  EVALUATION_DETAIL_VIEW_TAB_SET
} from '../../actions';
 
const INIT_STATE = {
  loading: true,
  file: [],
  list: {
    header:{
      name: 'code',
      order:'sorted-asc'
    },
    page:{
      current: 1,
      rows: 300
    }
  },
  add: {
    data: {
      new:{ id_evaluation: null, evaluation: null, id_answer: null, answer: null, id_document: null, document: null, reference: '', observation: '', description: ''}
    },
    modal: false,
    loading: false,
    message: '',
    url: '',
    type: ''
  },
  error: false,
  search:{
    modal: false,
    init:true,
    data:{
      evaluation: false,
      answer: false,
      document: false
    },
    value:{
      evaluation: false,
      answer: false,
      document: false
    },
    evaluation:{
      loading: true,
      list:[],
      message: ''
    },
    answer:{
      loading: true,
      list:[],
      message: ''
    },
    document:{
      loading: true,
      list:[],
      message: ''
    }
  },
  detail: {
    data: [],
    tab: 'general',
    loading: true,
  },
  view: {
    loading: true,
    data: [],
    tab: 'general',
    modal: false,
    log: {
      data: [],
      loading: false,
    },
  },
  edit: {
    loading: true,
    data: {
        new: [],
        old: []
    },
    list: {
        status: {
            data: [],
            loading: false,
        }
    },
    modal: false,
    update: {
        loading: false,
        response: '',
        message: ''
    }
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EVALUATION_DETAIL_LIST:
      return {
        ...state,
        loading: true,
        list: {
          ...state.list
        }
        
      }
    case EVALUATION_DETAIL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: {
          ...state.list,
          ...action.payload
        } 
      }
    case EVALUATION_DETAIL_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case EVALUATION_DETAIL_SEARCH_SET:
      return {
        ...state,
        search:{
          ...state.search,
          data: action.payload,
        }
      }
    case EVALUATION_DETAIL_SEARCH_CHANGE:
      return {
        ...state,
        search:{
          ...state.search,
          value: action.payload,
        }
      }
    case EVALUATION_DETAIL_PAGE_SET:
      return {
        ...state,
        list: {
          ...state.list,
          page: {
            ...state.list.page,
            ... action.payload,
          }
        },
        log: []
      }
    case EVALUATION_DETAIL_SEARCH_EVALUATION:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          evaluation:{
            ...state.search.evaluation,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_EVALUATION_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          evaluation:{
            ...state.search.evaluation,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_EVALUATION_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          evaluation:{
            ...state.search.evaluation,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_ANSWER:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          answer:{
            ...state.search.answer,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_ANSWER_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          answer:{
            ...state.search.answer,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_ANSWER_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          answer:{
            ...state.search.answer,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_DOCUMENT:
      return {
        ...state,
        search:{
          ...state.search,
          init:false,
          document:{
            ...state.search.document,
            loading: true,
            list:[],
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_DOCUMENT_SUCCESS:
      return {
        ...state,
        search:{
          ...state.search,
          document:{
            ...state.search.document,
            loading: false,
            list: action.payload,
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_SEARCH_DOCUMENT_ERROR:
      return {
        ...state,
        search:{
          ...state.search,
          document:{
            ...state.search.document,
            loading: false,
            list:[],
            message: 'No se encotraron datos'
          }
        }
      }
    case EVALUATION_DETAIL_ADD_CHANGE:
      return {
        ...state,
        add: {
          ...state.add,
          data: {
            ...state.add.data,
            new: {
              ...state.add.data.new,
              ...action.payload
            }
          }
        }
      }
    case EVALUATION_DETAIL_ADD_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: action.payload
        }
      }
    case EVALUATION_DETAIL_ADD_MODAL_SET:
      return {
        ...state,
        add: {
          ...state.add,
          data: { 
            ...state.add.data,
            new: { id_evaluation: null, evaluation: null, id_answer: null, answer: null, id_document: null, document: null, reference: '', observation: '', description: '' }
          },
          modal: action.payload
        }
      }
    case EVALUATION_DETAIL_ADD:
      return {
        ...state,
        add: {
          ...state.add, 
          loading: true
        }
      }
    case EVALUATION_DETAIL_ADD_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          modal: false,
          loading: false,
          message: action.payload.message,
          id: action.payload.id
        }
      }
    case EVALUATION_DETAIL_ADD_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          loading: false,
          message: action.payload.message
        }
      }
    case EVALUATION_DETAIL_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true
        }
      }
    case EVALUATION_DETAIL_DETAIL_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload
        },
        edit: {
          ...state.edit,
          loading: false,
          data: {
            new: action.payload,
            old: action.payload
          }
        }
      }
    case EVALUATION_DETAIL_DETAIL_ERROR:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false
        }
      }
    case EVALUATION_DETAIL_VIEW_MODAL_SET:
      return {
        ...state,
        view: {
          ...state.view,
          modal: action.payload
        }
      }
    case EVALUATION_DETAIL_EDIT_MODAL_SET:
      return {
        ...state,
        edit: {
          ...state.edit,
          modal: action.payload
        }
      }
    case EVALUATION_DETAIL_EDIT_CHANGE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              ...action.payload
            }
          }
        }
      }
    case EVALUATION_DETAIL_UPDATE:
      return {
        ...state,
        edit: {
          ...state.edit,
          data: {
            ...state.edit.data,
            ...action.payload,
          },
          update: {
            ...state.update,
            loading: true,
            response: '',
            message: ''
          }
        }
      }
    case EVALUATION_DETAIL_UPDATE_SUCCESS:
      return {
        ...state,
        edit: { 
          ...state.edit,
          modal: false,
          data: {
            ...state.edit.data,
            new: {
              ...state.edit.data.new,
              update_reason: ''
            },
            old: {
              ...state.edit.data.new,
              update_reason: ''
            }
          },
          update: {
            ...state.update,
            loading: false,
            response: 'success',
            message: action.payload
          }
        },
        view: {
          ...state.view,
          modal: false
        }
      }
    case EVALUATION_DETAIL_UPDATE_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          update: {
            ...state.update,
            loading: false,
            response: 'error',
            message: action.payload
          }
        }
      }
    case EVALUATION_DETAIL_VIEW_TAB_SET:
      return {
        ...state,
        view: {
          ...state.view,
          tab: action.payload
        }
      }
    default:
      return { ...state };
    }

};